module.exports = __webpack_public_path__ + "static/media/cards_32.d981b8e1.png";